import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setNavBredcrumb } from "../../store/reducers/slices/topnav.slice";
import ReportsPage from "../../components/pages/ReportsPage";
import { getRecentAnalyzedReports } from "../../api/homepage";
import { setHomeDetails, setHomeError, setHomeLoading } from "../../store/reducers/slices/home.slice";
import { PlusOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";



const ReportsPageWrapper = () => {
    const dispatch = useDispatch();
    const [reportData, setReportData] = useState(null);
    const { homeDetails } = useSelector(({ home }) => home);

    // console.log("HOME DETAILS ::::", homeDetails);


    useEffect(() => {
        dispatch(setNavBredcrumb([{ title: "" }]));
        dispatch(setHomeLoading(true));
        // API can be called here
        const fetchData = async () => {
            try {
                const response = await getRecentAnalyzedReports(0, 25, "desc", "lastUpdationOn", "");
                dispatch(setHomeDetails(response));
                setReportData(response);
                dispatch(setHomeLoading(false));
            } catch (error) {
                dispatch(setHomeError(error.message));
                dispatch(setHomeLoading(false));
                console.log("ERROR", error);
            }
        }

        if (!homeDetails) {
            fetchData();
        } else {
            setReportData(homeDetails);
        }
    }, []);
    return (
        <ReportsPage homeData={reportData} />
    );
};

export default ReportsPageWrapper;
